import { render, staticRenderFns } from "./BasePlaceholder.vue?vue&type=template&id=a1a66ed4&"
import script from "./BasePlaceholder.vue?vue&type=script&lang=js&"
export * from "./BasePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./BasePlaceholder.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports